import { useStripeLinks } from "@/lib/stripe";
import { ArrowRight } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 font-bold tracking-widest uppercase px-8 py-4 rounded-sm transition-colors duration-300 text-xs sm:text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A45C]";
const variants = {
  primary: "bg-[#C9A45C] text-[#080808] hover:bg-[#E8D5A3]",
  secondary:
    "bg-transparent border-2 border-[#C9A45C] text-[#C9A45C] hover:bg-[#C9A45C]/10",
};

export const CtaButton = ({
  plan,
  children,
  variant = "primary",
  testid,
  className = "",
  showArrow = false,
}) => {
  const { appUrl, communityUrl } = useStripeLinks();
  const url = plan === "app" ? appUrl : communityUrl;
  const styles = `${base} ${variants[variant]} ${className}`;

  if (!url) {
    return (
      <span
        data-testid={testid}
        className={`${styles} opacity-60 cursor-not-allowed`}
        title="Link di pagamento in configurazione"
      >
        {children}
      </span>
    );
  }
  return (
    <a
      data-testid={testid}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles}
    >
      {children}
      {showArrow && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
    </a>
  );
};
